import CurrrencyCodeAPI from '../../../api/CurrencyCode';
import CurrencyCode from "../../../models/currencyCode/currencyCode";

export default {
  async loadAllCurrencyCode({
    commit
  }) {
    const response = await new CurrrencyCodeAPI().all();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(CurrencyCode.createFromData(response[i]));
    }
    commit("SET_CURRENCY_CODE", result);
  },

  async currencyImport({commit}, data) {
    return await new CurrrencyCodeAPI().excelImport(data);
  }
};
